import { render, staticRenderFns } from "./NewsListItem.vue?vue&type=template&id=fb873270&"
import script from "./NewsListItem.vue?vue&type=script&lang=js&"
export * from "./NewsListItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsListItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports